import { render, staticRenderFns } from "./OrganizationEdit.vue?vue&type=template&id=0ced362a&scoped=true"
import script from "./OrganizationEdit.vue?vue&type=script&lang=js"
export * from "./OrganizationEdit.vue?vue&type=script&lang=js"
import style0 from "./OrganizationEdit.vue?vue&type=style&index=0&id=0ced362a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ced362a",
  null
  
)

export default component.exports